/**
 * 工作流事件
 */
export enum WfEvents {
    ShowTips = "ShowTips",
}